import { useMemo } from "react";
import { useTabs } from "./hooks";

import type { AllHTMLAttributes, ReactNode } from "react";

import styles from "./tabs-content.module.css";

export type TabsContentProps = {
  children: ReactNode;
  name: string;
} & AllHTMLAttributes<HTMLDivElement>;

export function TabsContent({ name, children, ...props }: TabsContentProps) {
  const { isActive } = useTabs();

  const className = useMemo(() => {
    if (isActive(name)) {
      return `${styles.Container} ${styles.Active}`;
    }

    return styles.Container;
  }, [isActive, name]);

  return (
    <div className={className} {...props}>
      {children}
    </div>
  );
}
